export const truncateLongName = (name: string): string => {
  return name.length > 14 ? 'Recipient' : name;
};
